import { useState } from "react";
import { ComposedChart, Bar, Line, XAxis, YAxis, Tooltip, ResponsiveContainer, Legend, ReferenceLine, CartesianGrid } from "recharts";
import { monthLabel, money } from "./roasUtil";

const short = (n) => (n >= 1e7 ? `${(n / 1e7).toFixed(1)}Cr` : n >= 1e5 ? `${(n / 1e5).toFixed(1)}L` : n >= 1e3 ? `${Math.round(n / 1e3)}k` : `${Math.round(n)}`);

export function RoasTrend({ d }) {
  const [mode, setMode] = useState(d.months.length > 1 ? "month" : "day");
  const target = d.totals.target_roas;
  const data = mode === "month"
    ? d.months.map((m) => ({ label: monthLabel(m.month), spend: m.spend, revenue: m.revenue, roas: m.roas, target: m.target_roas }))
    : d.days.map((x) => ({ label: x.date.slice(5), spend: x.spend, revenue: x.revenue, roas: x.cum_roas, target }));
  return (
    <section className="panel p-4" data-testid="roas-trend">
      <div className="flex items-center gap-3 mb-2">
        <div className="text-sm font-medium flex-1">Spend vs sales{mode === "day" ? " (ROAS line is running total)" : ""}</div>
        {["month", "day"].map((k) => <button key={k} className={`text-xs ${mode === k ? "text-[var(--ai)]" : "text-[var(--text-dim)]"}`} onClick={() => setMode(k)} data-testid={`roas-trend-${k}`}>{k === "month" ? "Monthly" : "Daily"}</button>)}
      </div>
      <div className="h-64">
        <ResponsiveContainer width="100%" height="100%">
          <ComposedChart data={data} margin={{ top: 5, right: 5, left: 0, bottom: 0 }}>
            <CartesianGrid stroke="var(--border)" strokeDasharray="2 4" vertical={false} />
            <XAxis dataKey="label" tick={{ fontSize: 10, fill: "var(--text-dim)" }} interval="preserveStartEnd" />
            <YAxis yAxisId="m" tickFormatter={short} tick={{ fontSize: 10, fill: "var(--text-dim)" }} width={44} />
            <YAxis yAxisId="r" orientation="right" tickFormatter={(v) => `${v}x`} tick={{ fontSize: 10, fill: "var(--text-dim)" }} width={36} />
            <Tooltip contentStyle={{ background: "var(--panel)", border: "1px solid var(--border)", fontSize: 12 }}
              formatter={(v, n) => (n === "ROAS" || n === "Target" ? [v == null ? "\u2014" : `${Number(v).toFixed(2)}x`, n] : [money(v), n])} />
            <Legend wrapperStyle={{ fontSize: 11 }} />
            <Bar yAxisId="m" dataKey="spend" name="Spend" fill="var(--text-faint)" radius={[2, 2, 0, 0]} />
            <Bar yAxisId="m" dataKey="revenue" name="Sales" fill="var(--ok)" radius={[2, 2, 0, 0]} />
            <Line yAxisId="r" dataKey="roas" name="ROAS" stroke="var(--ai)" strokeWidth={2} dot={mode === "month"} connectNulls />
            {mode === "month" ? <Line yAxisId="r" dataKey="target" name="Target" stroke="var(--warn)" strokeDasharray="4 4" dot={false} />
              : target ? <ReferenceLine yAxisId="r" y={target} stroke="var(--warn)" strokeDasharray="4 4" /> : null}
          </ComposedChart>
        </ResponsiveContainer>
      </div>
    </section>
  );
}
